export enum USER_ROLES {
    SYSTEM_ADMIN = "SYSTEM_ADMIN",
    DOCUMENTS_ADMIN = "DOCUMENTS_ADMIN",
    USER = "USER",
}

export interface CurrentUser {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    position: string;
    phoneNumber: string;
    role: USER_ROLES;
    group: UserGroup[],
    avatarBase64: string;
    isAdUser: boolean;
}

export interface CreateUserRequest {
    name: string;
    surname: string;
    position: string;
    phoneNumber: string;
    isActive: boolean;
    sendWelcomeEmail: boolean;
    email: string;
    password: string;
}

export interface SortType {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

export interface User {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    createdAt: string;
    role: USER_ROLES;
    activated: boolean;
    position: string;
    phoneNumber: string;
    isAdUser: boolean;
}

export interface UserResponse {
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
    size: number;
    content: User[];
    number: number;
    sort: SortType;
    numberOfElements: number;
    pageable: {
        offset: number;
        sort: SortType,
        paged: boolean;
        pageSize: number;
        pageNumber: number;
        unpaged: boolean;
    },
    empty: boolean;
}



export interface UpdateUserRequest {
    firstName?: string;
    lastName?: string;
    position?: string | null;
    phoneNumber?: string | null;
    isActive?: boolean;
    role?: USER_ROLES;
    newPassword?: string;
}

export interface UserUpdateResponse {
    message: string;
    success: boolean;
}

interface UserGroup {
    id: number;
    name: string;
    createdAt: string;
    isDefault: boolean;
}

